import { zodResolver } from '@hookform/resolvers/zod'
import { useCallback } from 'react'
import { Controller, useForm } from 'react-hook-form'

import { Button } from '~/components/Button'
import { MaskedInput, TextInput } from '~/components/TextInput'
import { documentNumberMask } from '~/components/TextInput/utils/mask'
import {
  personalTrainerSignUpSchema,
  PersonalTrainerSingUpDTO,
} from '~/modules/personalTrainer/schema'

type Props = {
  onSubmit(payload: PersonalTrainerSingUpDTO): Promise<void>
  buttonLabel?: string
}

export const PersonalTrainerSignUpForm: React.FC<Props> = ({
  onSubmit,
  buttonLabel = 'Cadastrar',
}) => {
  const {
    register,
    control,
    formState: { errors, isSubmitting },
    handleSubmit,
  } = useForm<PersonalTrainerSingUpDTO>({
    resolver: zodResolver(personalTrainerSignUpSchema),
  })

  const handleSubmitForm = useCallback(
    async (payload: PersonalTrainerSingUpDTO) => {
      await onSubmit(payload)
    },
    [onSubmit],
  )

  return (
    <form
      className='flex flex-col gap-2'
      onSubmit={handleSubmit(handleSubmitForm)}
    >
      <TextInput
        {...register('name')}
        error={errors.name?.message}
        label='Seu nome'
      />

      <Controller
        control={control}
        name='phoneNumber'
        render={({ field }) => (
          <MaskedInput
            mask='phone'
            inputMode='tel'
            label='Seu telefone'
            value={field.value}
            onChange={(v) => field.onChange(v)}
            error={errors.phoneNumber?.message}
          />
        )}
      />

      <div className='flex flex-col sm:flex-row gap-x-4 gap-y-2 '>
        <TextInput
          label='E-mail'
          {...register('email')}
          autoComplete='off'
          autoCapitalize='off'
          error={errors.email?.message}
        />
        <Controller
          control={control}
          name='documentNumber'
          defaultValue=''
          render={({ field }) => (
            <TextInput
              inputMode='numeric'
              label='Número de CPF'
              value={field.value}
              onChange={(e) =>
                field.onChange(documentNumberMask(e.target.value))
              }
              error={errors.documentNumber?.message}
            />
          )}
        />
      </div>

      <TextInput
        label='Senha'
        type='password'
        {...register('password')}
        error={errors.password?.message}
      />

      <TextInput
        label='Confirme Sua Senha'
        type='password'
        autoComplete='off'
        {...register('confirmPassword')}
        error={errors.confirmPassword?.message}
      />

      <Button loading={isSubmitting}>{buttonLabel}</Button>
    </form>
  )
}
